import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { trigger, transition, style, animate } from '@angular/animations';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { navItems } from '../sidebar/sidebar-data';
import { AuthService } from 'src/app/services/authService';
import { NotificacionesTurnosService } from 'src/app/modules/citas/services/notificaciones-turnos.service';
import { TurnoAtencionActivaService } from 'src/app/modules/citas/services/turno-atencion-activa.service';
import { CitasService } from 'src/app/modules/citas/services/citas.service';
import { NotificacionTurno, TurnoAsignadoEvento, TurnoAtencionActiva } from 'src/app/modules/citas/models/citas.models';
import {
  ConcluirAtencionDialogComponent,
} from 'src/app/modules/citas/gestion/zona-atencion-turnos/concluir-atencion-dialog.component';
import { puedeConcluirAtencionTurno } from 'src/app/modules/citas/utils/citas-turno-atencion.util';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subscription } from 'rxjs';
import { HORIZONTAL_MENU_MEDIA } from '../horizontal-layout.constants';
import { SocioOperacionEstadoService } from 'src/app/modules/administracion/administracion-socios/services/socio-operacion-estado.service';

interface profiledd {
  id: number;
  img: string;
  title: string;
  color: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-horizontal-header',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    FormsModule,
    MatMenuModule,
    MatButtonModule
],
  templateUrl: './header.component.html',
  animations: [
    trigger('turnoNuevoCard', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('450ms ease-in-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('450ms ease-out', style({ transform: 'translateY(-100%)', opacity: 0 })),
      ]),
    ]),
  ],
  styles: [`
    .header-container {
      display: flex;
      align-items: center;
      width: 100%;
    }
    .header-container--con-turno {
      display: grid;
      grid-template-columns: auto minmax(0, 1fr) auto;
      column-gap: 12px;
      align-items: center;
      width: 100%;
    }
    .header-start {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .header-center {
      min-width: 0;
      width: 100%;
      display: flex;
      justify-content: stretch;
    }
    .header-end {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin-left: auto;
    }
    .header-container--con-turno .header-end {
      margin-left: 0;
    }
    .panel-en-atencion {
      width: 100%;
      height: 70px;
      box-sizing: border-box;
      margin: 0 8px;
      padding: 6px 16px;
      border: 2px solid #0084E2;
      border-radius: 4px;
      background: #fff;
      color: #1e293b;
      position: relative;
      isolation: isolate;
      max-width: 50vw;
      flex-shrink: 1;
      container-type: inline-size;
      container-name: panel-atencion;
      box-shadow:
        0 0 0 1px rgba(0, 132, 226, 0.08),
        0 4px 12px rgba(0, 132, 226, 0.14);
    }
    .header-container--con-turno .panel-en-atencion {
      max-width: none;
      margin: 0;
      width: 100%;
    }
    .panel-en-atencion-body {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      width: 100%;
      height: 100%;
      min-width: 0;
      position: relative;
      z-index: 1;
    }
    .panel-en-atencion-detalle {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      gap: 2px;
      overflow: hidden;
      height: 100%;
    }
    .panel-en-atencion-titulo {
      font-size: 0.75rem;
      font-weight: 700;
      line-height: 1.2;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: #0084E2;
      white-space: nowrap;
      flex-shrink: 0;
    }
    .panel-en-atencion-linea {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      gap: 12px;
      min-width: 0;
      width: 100%;
      overflow: hidden;
      line-height: 1.25;
    }
    .panel-en-atencion-linea--superior .panel-campo--nombre {
      flex: 1 1 auto;
      min-width: 0;
    }
    .panel-en-atencion-linea--inferior {
      flex: 1 1 auto;
      min-height: 0;
    }
    .panel-campo {
      display: flex;
      align-items: baseline;
      gap: 4px;
      min-width: 0;
      max-width: 100%;
      font-size: 0.8125rem;
      line-height: 1.25;
      white-space: nowrap;
      flex-shrink: 1;
    }
    .panel-campo-label {
      font-weight: 600;
      flex-shrink: 0;
      color: #475569;
    }
    .panel-campo-valor {
      font-weight: 500;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #0f172a;
    }
    .panel-en-atencion-ver {
      display: none;
      flex-shrink: 0;
      width: 28px;
      height: 28px;
      line-height: 28px;
      color: #0084E2;
    }
    .panel-en-atencion-acciones {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-end;
      gap: 6px;
      flex: 0 0 auto;
      max-height: 100%;
    }
    .panel-en-atencion-btn {
      min-height: 28px !important;
      height: 28px !important;
      padding: 0 10px !important;
      font-size: 0.75rem !important;
      line-height: 1.1 !important;
      font-weight: 600 !important;
    }
    :host ::ng-deep .panel-en-atencion-acciones .panel-en-atencion-btn--pausar.mat-mdc-outlined-button {
      --mdc-outlined-button-outline-color: #ffc107;
      --mdc-outlined-button-label-text-color: #1a1a1a;
      --mat-outlined-button-state-layer-color: #ffc107;
      background: #ffc107;
    }
    :host ::ng-deep .panel-en-atencion-acciones .panel-en-atencion-btn--asignar.mat-mdc-raised-button {
      --mdc-protected-button-container-color: #ef6c00;
      --mdc-protected-button-label-text-color: #fff;
    }
    :host ::ng-deep .panel-en-atencion-acciones .panel-en-atencion-btn--concluir.mat-mdc-unelevated-button {
      --mdc-filled-button-container-color: #0084E2;
      --mdc-filled-button-label-text-color: #fff;
      --mat-filled-button-state-layer-color: #0084E2;
    }
    :host ::ng-deep .panel-en-atencion-ver.mat-mdc-icon-button {
      --mdc-icon-button-icon-color: #0084E2;
      color: #0084E2;
    }
    /* Comentario: primero nombre (más largo, fila superior); luego trámite; RFC al final; ojo al ocultar trámite */
    @container panel-atencion (max-width: 420px) {
      .panel-campo--nombre {
        display: none;
      }
    }
    @container panel-atencion (max-width: 480px) {
      .panel-campo--tramite {
        display: none;
      }
      .panel-en-atencion-ver {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
    @container panel-atencion (max-width: 360px) {
      .panel-campo--rfc {
        display: none;
      }
    }
    :host ::ng-deep .panel-en-atencion-tooltip {
      white-space: pre-line;
      max-width: 320px;
      font-size: 0.8125rem;
      line-height: 1.4;
    }
    .notif-item {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 8px;
      text-align: left;
    }
    .notif-item--nuevo {
      background: rgba(25, 118, 210, 0.08);
      font-weight: 600;
    }
    .notif-item--visto {
      opacity: 0.75;
    }
    .notif-borrar {
      flex-shrink: 0;
    }
    .badge-notif {
      position: absolute;
      top: 4px;
      right: 4px;
      min-width: 18px;
      height: 18px;
      font-size: 11px;
      line-height: 18px;
      border-radius: 9px;
      background: #e53935;
      color: #fff;
      text-align: center;
      padding: 0 4px;
    }
    .btn-notif-wrap {
      position: relative;
    }
    .socio-op-chip {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      max-width: 280px;
      margin-right: 8px;
      padding: 4px 12px;
      border-radius: 16px;
      background: #e8eef8;
      color: #003399;
      font-size: 12px;
      font-weight: 600;
      line-height: 1.2;
      white-space: nowrap;
    }
    .socio-op-chip span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .seccion-notif-titulo {
      font-size: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      opacity: 0.7;
      padding: 8px 32px 4px;
    }
    .turno-nuevo-card-anchor {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1200;
      pointer-events: auto;
      max-width: min(420px, calc(100vw - 32px));
      width: 100%;
    }
    .turno-nuevo-card {
      background: #0F74BB;
      color: #fff;
      border-radius: 0 0 16px 16px;
      box-shadow: 0 10px 28px rgba(15, 23, 42, 0.28);
      overflow: hidden;
    }
    .turno-nuevo-card__contenido {
      padding: 18px 20px 14px;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
    .turno-nuevo-card__titulo {
      margin: 0;
      font-size: 0.9375rem;
      font-weight: 700;
      line-height: 1.35;
    }
    .turno-nuevo-card__linea {
      margin: 0;
      font-size: 0.8125rem;
      line-height: 1.4;
      opacity: 0.95;
    }
    .turno-nuevo-card__linea strong {
      font-weight: 600;
    }
    .turno-nuevo-card__btn {
      position: relative;
      display: block;
      width: 100%;
      border: none;
      margin: 0;
      padding: 12px 16px;
      color: #fff;
      font-size: 0.875rem;
      font-weight: 600;
      cursor: pointer;
      overflow: hidden;
      border-radius: 0 0 16px 16px;
    }
    .turno-nuevo-card__btn-fondo {
      position: absolute;
      inset: 0;
      background: #15376C;
      opacity: 0.2;
      z-index: 0;
    }
    .turno-nuevo-card__btn-llenado {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      background: #15376C;
      z-index: 1;
      transition: width 1s linear;
    }
    .turno-nuevo-card__btn-texto {
      position: relative;
      z-index: 2;
    }
  `],
})
export class AppHorizontalHeaderComponent implements OnInit, OnDestroy {
  searchText: string = '';
  userName: string = 'demo name';
  userCorreo: string = 'demo correo';
  userRole: string = 'demo rolname';

  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  navItemsData = navItems.filter((navitem) => navitem.displayName);
  showFiller = false;

  notificacionesAtencion$: Observable<NotificacionTurno[]>;
  nuevasCount$: Observable<number>;
  turnoActivo$: Observable<TurnoAtencionActiva | null>;
  /** Turno en atención sincrónico para alternar layout del header */
  turnoEnAtencion: TurnoAtencionActiva | null = null;
  /** Comentario: alineado con visibilidad del menú horizontal (1100px) */
  menuHorizontalVisible = false;
  /** Card deslizable de turno nuevo */
  cardTurnoVisible = false;
  cardTurnoActual: NotificacionTurno | null = null;
  segundosCardTurno = 10;
  progresoBotonCard = 0;

  private readonly duracionCardTurnoSeg = 10;
  private colaCardsTurno: NotificacionTurno[] = [];
  private intervaloCardTurno: ReturnType<typeof setInterval> | null = null;
  private timeoutCierreCardTurno: ReturnType<typeof setTimeout> | null = null;

  private subs = new Subscription();
  private horizontalMenuQuery: MediaQueryList;
  private horizontalMenuQueryListener: () => void;
  private changeDetectorRef: ChangeDetectorRef;

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    { language: 'English', code: 'en', type: 'US', icon: '/assets/images/flag/icon-flag-en.svg' },
    { language: 'Español', code: 'es', icon: '/assets/images/flag/icon-flag-es.svg' },
    { language: 'Français', code: 'fr', icon: '/assets/images/flag/icon-flag-fr.svg' },
    { language: 'German', code: 'de', icon: '/assets/images/flag/icon-flag-de.svg' },
  ];

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private notificaciones: NotificacionesTurnosService,
    private turnoActivo: TurnoAtencionActivaService,
    private citas: CitasService,
    private snack: MatSnackBar,
    public socioOpEstado: SocioOperacionEstadoService,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    this.changeDetectorRef = changeDetectorRef;
    this.horizontalMenuQuery = media.matchMedia(HORIZONTAL_MENU_MEDIA);
    this.menuHorizontalVisible = this.horizontalMenuQuery.matches;
    this.horizontalMenuQueryListener = () => {
      this.menuHorizontalVisible = this.horizontalMenuQuery.matches;
      changeDetectorRef.markForCheck();
    };
    this.horizontalMenuQuery.addListener(this.horizontalMenuQueryListener);
    translate.setDefaultLang('en');
    this.userName = localStorage.getItem('nombre') || 'demo Name';
    this.userCorreo = localStorage.getItem('correo') || 'demo Correo';
    this.userRole = localStorage.getItem('role') || 'demo Role';
    this.notificacionesAtencion$ = this.notificaciones.atencionTurnos$;
    this.nuevasCount$ = this.notificaciones.nuevasCount$;
    this.turnoActivo$ = this.turnoActivo.activo$;
  }

  ngOnInit(): void {
    this.subs.add(
      this.turnoActivo$.subscribe((turno) => {
        this.turnoEnAtencion = turno;
      }),
    );
    // Comentario: muestra card al recibir turno nuevo en tiempo real
    this.subs.add(
      this.notificaciones.nuevaNotificacion$.subscribe((notif) => {
        this.encolarCardTurno(notif);
      }),
    );
    // Restaura turno en atención al recargar si el backend lo reporta
    const usuarioId = localStorage.getItem('usuario_id');
    if (usuarioId && !this.turnoActivo.activo) {
      const uid = parseInt(usuarioId, 10);
      if (!Number.isNaN(uid)) {
        this.citas.obtenerMiPerfilRepresentante(uid).subscribe({
          next: (perfil) => {
            this.citas.listarTurnosAsignados(perfil.representante_id).subscribe({
              next: (resp) => {
                const activo = resp.turno_en_atencion ?? resp.turnos?.find((t) => t.en_atencion);
                if (activo) {
                  this.turnoActivo.establecerDesdeTurno(activo, perfil.representante_id);
                }
              },
            });
          },
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.horizontalMenuQuery.removeListener(this.horizontalMenuQueryListener);
    this.detenerContadorCardTurno();
    if (this.timeoutCierreCardTurno) {
      clearTimeout(this.timeoutCierreCardTurno);
    }
    this.subs.unsubscribe();
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);
    dialogRef.afterClosed().subscribe(() => {});
  }

  logout() {
    this.authService.logout();
  }

  /** Comentario: encola cards si ya hay uno visible */
  private encolarCardTurno(notif: NotificacionTurno): void {
    if (this.cardTurnoVisible) {
      this.colaCardsTurno.push(notif);
      return;
    }
    this.mostrarCardTurno(notif);
  }

  /** Comentario: muestra card con contador de 10 segundos */
  private mostrarCardTurno(notif: NotificacionTurno): void {
    this.cardTurnoActual = notif;
    this.segundosCardTurno = this.duracionCardTurnoSeg;
    this.progresoBotonCard = 0;
    this.cardTurnoVisible = true;
    this.iniciarContadorCardTurno();
  }

  /** Comentario: tick cada segundo para texto y llenado del botón */
  private iniciarContadorCardTurno(): void {
    this.detenerContadorCardTurno();
    this.intervaloCardTurno = setInterval(() => {
      this.segundosCardTurno -= 1;
      if (this.segundosCardTurno <= 0) {
        this.progresoBotonCard = 100;
        this.cerrarCardTurno(false);
        return;
      }
      this.progresoBotonCard =
        ((this.duracionCardTurnoSeg - this.segundosCardTurno) / this.duracionCardTurnoSeg) * 100;
      this.changeDetectorRef.markForCheck();
    }, 1000);
  }

  /** Comentario: detiene intervalo del contador */
  private detenerContadorCardTurno(): void {
    if (this.intervaloCardTurno) {
      clearInterval(this.intervaloCardTurno);
      this.intervaloCardTurno = null;
    }
  }

  /** Comentario: cierra card al aceptar o al terminar contador */
  aceptarCardTurno(): void {
    this.cerrarCardTurno(true);
  }

  /** Comentario: cierra card; solo marca vista si el usuario aceptó */
  private cerrarCardTurno(porClick: boolean): void {
    if (!this.cardTurnoVisible) {
      return;
    }
    this.detenerContadorCardTurno();
    if (porClick && this.cardTurnoActual) {
      this.notificaciones.marcarVisto(this.cardTurnoActual.id);
    }
    this.cardTurnoVisible = false;
    this.changeDetectorRef.markForCheck();
    if (this.timeoutCierreCardTurno) {
      clearTimeout(this.timeoutCierreCardTurno);
    }
    // Comentario: espera animación de salida antes del siguiente card
    this.timeoutCierreCardTurno = setTimeout(() => {
      this.cardTurnoActual = null;
      this.changeDetectorRef.markForCheck();
      const siguiente = this.colaCardsTurno.shift();
      if (siguiente) {
        this.mostrarCardTurno(siguiente);
      }
    }, 450);
  }

  /** Texto de trámites para card de turno nuevo */
  tramitesCardTurno(payload: TurnoAsignadoEvento): string {
    const tramites = (payload.tramites ?? []).filter(Boolean);
    return tramites.length ? tramites.join(', ') : '—';
  }

  /** Hora de cita o, en su defecto, hora del turno */
  horaCardTurno(payload: TurnoAsignadoEvento): string {
    if (payload.cita_id && payload.hora_cita) {
      return `Cita: ${this.formatearHoraCard(payload.hora_cita)}`;
    }
    if (payload.hora_llegada) {
      return `Turno: ${this.formatearHoraDesdeIso(payload.hora_llegada)}`;
    }
    return '—';
  }

  /** Comentario: formatea hora HH:MM desde string de hora */
  private formatearHoraCard(hora?: string | null): string {
    if (!hora) {
      return '—';
    }
    const parte = hora.trim();
    if (parte.length >= 5 && parte.includes(':')) {
      return parte.slice(0, 5);
    }
    return parte;
  }

  /** Comentario: extrae hora de datetime ISO */
  private formatearHoraDesdeIso(iso?: string | null): string {
    if (!iso) {
      return '—';
    }
    const fecha = new Date(iso);
    if (Number.isNaN(fecha.getTime())) {
      return this.formatearHoraCard(iso);
    }
    return fecha.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
  }

  /** Texto de trámites para panel en atención */
  tramitesTexto(turno: TurnoAtencionActiva): string {
    const tramites = (turno.tramites ?? []).filter(Boolean);
    return tramites.length ? tramites.join(', ') : '—';
  }

  /** Etiqueta Nombre del maestro/maestra según género o visitante sin maestro */
  etiquetaMaestro(turno: TurnoAtencionActiva): string {
    if (!turno.maestro_id) {
      return 'Nombre';
    }
    return this.esGeneroFemenino(turno.genero) ? 'Nombre de la maestra' : 'Nombre del maestro';
  }

  /** Etiqueta Trámite/Trámites según cantidad */
  etiquetaTramite(turno: TurnoAtencionActiva): string {
    const n = (turno.tramites ?? []).filter(Boolean).length;
    return n === 1 ? 'Trámite' : 'Trámites';
  }

  /** Texto completo del turno para tooltip al ocultar campos */
  detalleTurnoTooltip(turno: TurnoAtencionActiva): string {
    return [
      `RFC: ${turno.rfc || '—'}`,
      `${this.etiquetaMaestro(turno)}: ${turno.nombre_socio || '—'}`,
      `${this.etiquetaTramite(turno)}: ${this.tramitesTexto(turno)}`,
    ].join('\n');
  }

  /** Comentario: detecta género femenino para etiqueta Maestra */
  private esGeneroFemenino(genero?: string | null): boolean {
    const g = (genero ?? '').trim().toUpperCase();
    return g === 'F' || g === 'FEMENINO' || g === 'FEMALE' || g === 'MUJER' || g === 'FEMENINA';
  }

  /** Resumen de notificación */
  tituloNotificacion(n: NotificacionTurno): string {
    return `Turno ${n.payload.numero_turno}`;
  }

  subtituloNotificacion(n: NotificacionTurno): string {
    const p = n.payload;
    const tram = (p.tramites ?? []).join(', ');
    return `${p.rfc || '—'} · ${p.nombre_socio || ''}${tram ? ' · ' + tram : ''}`;
  }

  /** Clase CSS según estatus de notificación */
  claseNotificacion(n: NotificacionTurno): string {
    if (n.estatus === 'nuevo') {
      return 'notif-item--nuevo';
    }
    return 'notif-item--visto';
  }

  /** Click en notificación: marca vista y navega */
  onClickNotificacion(n: NotificacionTurno, event: Event): void {
    event.stopPropagation();
    this.notificaciones.marcarVisto(n.id);
    this.router.navigate(['/citas-zona-atencion'], {
      queryParams: { turno_id: n.payload.turno_id },
    });
  }

  /** Borra notificación de la lista */
  onBorrarNotificacion(n: NotificacionTurno, event: Event): void {
    event.stopPropagation();
    this.notificaciones.borrar(n.id);
  }

  /** Navega al kárdex del turno en atención */
  irAlKardex(turno: TurnoAtencionActiva): void {
    if (!turno.maestro_id) {
      return;
    }
    this.router.navigate(['/kardex'], { queryParams: { id: turno.maestro_id } });
  }

  /** Navega a zona de atención para vincular o inscribir socio al turno activo */
  irAsignarInscribir(turno: TurnoAtencionActiva): void {
    this.router.navigate(['/citas-zona-atencion'], {
      queryParams: { turno_id: turno.turno_id, asignar: 1 },
    });
  }

  /** Pausa atención del turno activo y libera la cola */
  pausarAtencion(turno: TurnoAtencionActiva): void {
    this.citas.pausarAtencionTurno(turno.turno_id, turno.representante_id).subscribe({
      next: () => {
        this.turnoActivo.limpiar({ trasPausar: true });
        this.snack.open('Atención en pausa. Puede elegir otro turno.', 'Cerrar', { duration: 4000 });
        this.router.navigate(['/citas-zona-atencion']);
      },
      error: (e) => {
        this.snack.open(e.message, 'Cerrar', { duration: 5000 });
      },
    });
  }

  /** Indica si el turno en atención puede concluirse (socio o solicitud de informes). */
  puedeConcluirAtencion(turno: TurnoAtencionActiva): boolean {
    return puedeConcluirAtencionTurno(turno);
  }

  /** Abre modal y concluye atención del turno activo */
  abrirConcluirAtencion(turno: TurnoAtencionActiva): void {
    if (!puedeConcluirAtencionTurno(turno)) {
      this.snack.open(
        'Vincule un socio o registre la solicitud de información en zona de atención antes de concluir.',
        'Cerrar',
        { duration: 5000 },
      );
      return;
    }
    const ref = this.dialog.open(ConcluirAtencionDialogComponent, {
      width: '400px',
      data: {
        nombre: turno.nombre_socio,
        numeroTurno: turno.numero_turno,
      },
    });
    ref.afterClosed().subscribe((confirmar) => {
      if (!confirmar) {
        return;
      }
      this.citas.concluirAtencionTurno(turno.turno_id, turno.representante_id).subscribe({
        next: () => {
          this.turnoActivo.limpiar({ trasConcluir: true });
          this.snack.open('Atención concluida.', 'Cerrar', { duration: 3000 });
          this.router.navigate(['/citas-zona-atencion']);
        },
        error: (e) => {
          this.snack.open(e.message, 'Cerrar', { duration: 5000 });
        },
      });
    });
  }

  profiledd: profiledd[] = [
    { id: 1, img: 'wallet', color: 'primary', title: 'My Profile', subtitle: 'Account Settings', link: '/' },
    { id: 2, img: 'shield', color: 'success', title: 'My Inbox', subtitle: 'Messages & Email', link: '/' },
    { id: 3, img: 'credit-card', color: 'error', title: 'My Tasks', subtitle: 'To-do and Daily Tasks', link: '/' },
  ];
}

@Component({
  selector: 'search-dialog',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    NgScrollbarModule,
  ],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;
  navItemsData = navItems.filter((navitem) => navitem.displayName);
}
